<script>
import SelectUser from "./Steps/SelectUser";
import Address from "./Steps/Address";
import ToBe from "./Steps/ToBe";
import PerSchedule from "./PerSchedule";
import PerProfessional from "./PerProfessional";
import AdditionalInformations from "./Steps/AdditionalInformations";
import Confirmation from "./Steps/Confirmation";
import FloatingWarning from "@/components/_Shared/FloatingWarning";
import OrderCreated from "./Steps/OrderCreated";

import scrollToMixin from "@/mixins/scrollToMixin";

import { mapState, mapGetters, mapActions } from "vuex";

export default {
  mixins: [scrollToMixin],

  computed: {
    ...mapState("newOrder", [
      "address",
      "to_be",
      "professional",
      "day",
      "starts_at",
      "ends_at",
      "additional_informations",
      "price_confirmed",
      "user",
      "order"
    ])
  },

  components: {
    SelectUser,
    Address,
    ToBe,
    PerSchedule,
    PerProfessional,
    AdditionalInformations,
    Confirmation,
    FloatingWarning,
    OrderCreated
  },

  data() {
    return {
      created: false
    };
  },

  methods: {
    ...mapActions("newOrder", ["resetState"]),
    canShowAdditionalInformations() {
      return this.to_be === "schedule"
        ? this.professional && this.ends_at
        : this.price_confirmed;
    },

    canShowConfirmation() {
      return (
        this.professional &&
        this.additional_informations &&
        this.price_confirmed
      );
    },
    clearData() {
      this.resetState();
      this.created = false;
    }
  },

  beforeDestroy() {
    this.resetState();
  }
};
</script>

<template>
  <div class="box">
    <transition name="fade" mode="out-in">
      <order-created
        v-if="order && created"
        @clearData="clearData"
        :order="order"
      />

      <div v-else>
        <floating-warning
          v-if="user"
          title="Verifique seu email!"
          positionY="bottom"
          message="Acesse seu email para confirmar sua conta antes de realizar uma compra."
          :visible="user.status === 'waiting_email_verification'"
        />

        <transition name="fade" mode="out-in">
          <select-user
            :selected="address"
            :class="{ 'passed-on': address }"
            @scrollTo="scrollTo('#to-be')"
          />
        </transition>

        <transition name="fade" mode="out-in">
          <Address
            id="addresses"
            v-if="user"
            :selected="address"
            :class="{ 'passed-on': address }"
            @scrollTo="scrollTo('#to-be')"
          />
        </transition>

        <transition name="fade" mode="out-in">
          <to-be
            id="to-be"
            v-show="address"
            :class="{ 'passed-on': to_be }"
            @scrollTo="scrollTo('#to-be-selected')"
          />
        </transition>

        <transition name="fade" mode="out-in">
          <per-schedule
            v-if="to_be === 'schedule'"
            id="to-be-selected"
            @scrollTo="scrollTo($event)"
          />
        </transition>

        <transition name="fade" mode="out-in">
          <per-professional
            v-if="to_be === 'professional'"
            id="to-be-selected"
            @scrollTo="scrollTo($event)"
          />
        </transition>

        <transition name="fade" mode="out-in">
          <additional-informations
            v-if="canShowAdditionalInformations()"
            id="additional-informations"
            :class="{ 'passed-on': additional_informations }"
            @scrollTo="scrollTo('#confirmation')"
          />
        </transition>

        <transition name="fade" mode="out-in">
          <confirmation
            v-if="canShowConfirmation()"
            id="confirmation"
            @created="created = true"
          />
        </transition>
      </div>
    </transition>
  </div>
</template>

<style scoped>
.section {
  transition: all 0.24s ease;
}

.section.passed-on {
  opacity: 0.35;
}

.section.passed-on:hover,
.section.passed-on:active {
  opacity: 1;
}

.left {
  width: calc(70% - 10px);
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  margin-right: 10px;
}

.right {
  width: calc(30% - 10px);
  flex: none;
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  margin-right: 0;
}

.box {
  width: calc(100% - 80px);
  transition: all 0.25s ease;
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Index.vue